import * as React from 'react';
import moment from 'moment';

import {ButtonReact} from 'common/components/button';
import {ButtonTheme} from 'common/components/button/constants';
import {LastUpdatedReact} from 'common/components/last-updated';
import {SpinnerReact} from 'common/components/spinner';
import {SpinnerColor, SpinnerSize} from 'common/components/spinner/types';
import {SvgIconReact} from 'common/components/svg-icon';
import {react2panel} from 'common/util/react2panel';

import './index.styl';

export interface RefreshButtonJsxProps {
  isLoading: boolean;
  lastUpdated: string;
  onRefresh: (useQueryApiCache: boolean) => void;
}

const RefreshButton = (props: RefreshButtonJsxProps) => {
  const icon = props.isLoading ? (
    <SpinnerReact color={SpinnerColor.Blue} size={SpinnerSize.Small} />
  ) : (
    <SvgIconReact height={`4px`} icon={`refresh`} style={{height: `4px`}} />
  );

  const onClick = (ev: MouseEvent | React.MouseEvent) => {
    if (ev instanceof MouseEvent) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
    } else {
      ev.stopPropagation();
    }
    props.onRefresh(false);
  };

  const shouldShowRefresh = () => {
    if (!props.lastUpdated) {
      return false;
    }
    return moment().subtract(30, `minutes`).isAfter(moment(props.lastUpdated));
  };

  return shouldShowRefresh() ? (
    <div className={`refresh-controls`}>
      <ButtonReact
        className={`refresh-button`}
        disabled={props.isLoading}
        theme={ButtonTheme.Tertiary}
        onClick={(ev) => onClick(ev)}
      >
        {icon}
        {props.isLoading ? (
          `Updating...`
        ) : (
          <LastUpdatedReact isCompact lastRefreshDate={props.lastUpdated} refreshIntervalMs={1000} />
        )}
      </ButtonReact>
    </div>
  ) : (
    <></>
  );
};

export const RefreshButtonEl = react2panel(`mp-refresh-button`, RefreshButton);
export const RefreshButtonReact = RefreshButton;
